import React from 'react';
import {
  Table,
  TableHeader,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '../../../components/ui/table';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../components/ui/tooltip';
import { CopyButton } from '../../../components/ui/copy-button';
import { SeriesData } from '@/types/types';

interface SeriesTableProps {
  series: SeriesData[];
}

export const SeriesTable: React.FC<SeriesTableProps> = ({ series }) => {
  return (
    <div className="p-4">
      <div className="font-semibold mb-2">Series in this Study:</div>
      <div className="max-h-64 relative overflow-y-auto border-t-0 ">
        <Table className="border border-gray-300 rounded-[10px] border-separate border-spacing-0">
          <TableHeader className="sticky top-0 bg-muted">
            <TableRow>
              <TableHead className="border border-gray-300">
                Series Number
              </TableHead>
              <TableHead className="border border-gray-300">
                Series Instance UID
              </TableHead>
              <TableHead className="border border-gray-300">
                Series Description
              </TableHead>
              <TableHead className="border border-gray-300">Modality</TableHead>
              <TableHead className="border border-gray-300">
                Number of Instances
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {series.map((series) => (
              <TableRow key={series.SeriesInstanceUID}>
                <TableCell className="ml-2 border border-gray-300">
                  {series.SeriesNumber || '0'}
                </TableCell>
                <TableCell className="border border-gray-300">
                  <div className="flex items-center gap-2">
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <span className="cursor-pointer max-w-40 overflow-hidden truncate block">
                            {series.SeriesInstanceUID}
                          </span>
                        </TooltipTrigger>
                        <TooltipContent>
                          <span>{series.SeriesInstanceUID}</span>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                    <CopyButton 
                      value={series.SeriesInstanceUID}
                      label="Copy Series Instance UID"
                    />
                  </div>
                </TableCell>
                <TableCell className="ml-2 border border-gray-300">
                  {series.SeriesDescription || 'N/A'}
                </TableCell>
                <TableCell className="ml-2 border border-gray-300">
                  {series.Modality || 'N/A'}
                </TableCell>
                <TableCell className="ml-2 border border-gray-300">
                  {series.InstanceCount || '0'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
